// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-banner-style.top-section-gap {
  color: #fff;
  background-color: #181a20;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  position: relative;
  max-width: 100%;
  overflow-x: hidden;
  padding-top: 0;
  padding-bottom: 40px;
}

body.light_theme .hero-banner-style.top-section-gap {
  color: #0a0a0a;
  background-color: #ffffff;
}

.hero-banner-style.top-section-gap a {
  text-decoration: none;
  transition: 0.5s all;
}

.hero-banner-style.top-section-gap img {
  max-width: 100%;
}

.hero-banner-style.top-section-gap .container {
  max-width: 1440px;
  padding: 0 20px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.hero-banner-style.top-section-gap .row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -12px;
  margin-right: -12px;
}

.hero-banner-style.top-section-gap .row>* {
  padding-left: 12px;
  padding-right: 12px;
  box-sizing: border-box;
}

.hero-banner-style.top-section-gap .align-items-center {
  align-items: center !important;
}

.hero-banner-style.top-section-gap .justify-content-center {
  justify-content: center !important;
}

.hero-banner-style.top-section-gap .text-center {
  text-align: center !important;
}

.hero-banner-style.top-section-gap .col-md-12 {
  flex: 0 0 auto;
  width: 100%;
}

@media (min-width: 992px) {
  .hero-banner-style.top-section-gap .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
}

/* ========== HERO / TITLE ========== */

.hero-banner-style.top-section-gap section.faq_sec {
  padding: 40px 0 0;
}

.hero-banner-style.top-section-gap section.faq_sec .section-title {
  margin-bottom: 20px;
}

.hero-banner-style.top-section-gap .section-title {
  margin-bottom: 60px;
}

.hero-banner-style.top-section-gap .text-gradient {
  background: linear-gradient(135deg, #e0e0e0 30%, #d1aa67 80%, #d1aa67 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Force the flat gold instead of the global clipped gradient */

body.light_theme .hero-banner-style.top-section-gap .text-gradient {
  background: linear-gradient(135deg, #000000 30%, #d1aa67 80%, #d1aa67 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero-banner-style.top-section-gap .section-title h1 {
  font-family: "Inter", sans-serif;
  font-size: 3.4rem;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;
}

.hero-banner-style.top-section-gap .termsofuse {
  padding: 40px 0px 60px;
}

.hero-banner-style.top-section-gap .create-item-wrapper.plicy_sec {
  background: #ffffff0f;
  border: 1px solid #e2e8f012;
  border-radius: 16px;
  padding: 20px 32px;
  max-width: 100%;
  margin: 0 auto 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  color: #d9d9d9;
  font-size: 14.5px;
  line-height: 1.75;
}

body.light_theme .hero-banner-style.top-section-gap .create-item-wrapper.plicy_sec {
  /* background: #ffffff;
  border: 1px solid #e2e8f0; */
  color: #1b1b1c;
}

.hero-banner-style.top-section-gap .plicy_sec p {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.75;
  font-weight: 400;
}

.hero-banner-style.top-section-gap .plicy_sec>p:first-of-type {
  margin-bottom: 24px;
}

.hero-banner-style.top-section-gap .plicy_sec h3 {
  font-size: 18px;
  font-weight: 700;
  color: #ededed;
  margin: 28px 0 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f01f;
}

body.light_theme .hero-banner-style.top-section-gap .plicy_sec h3 {
  color: #0f172a;
  /* border-bottom: 1px solid #e2e8f0; */
}

.hero-banner-style.top-section-gap .plicy_sec strong,
.hero-banner-style.top-section-gap .plicy_sec b {
  color: #ffffff;
  font-weight: 700;
}

body.light_theme .hero-banner-style.top-section-gap .plicy_sec strong,
body.light_theme .hero-banner-style.top-section-gap .plicy_sec b {
  color: #0f172a;
}

.hero-banner-style.top-section-gap .plicy_sec a {
  color: #ce9f4e;
  text-decoration: none;
  font-weight: 500;
  word-break: break-word;
}

.hero-banner-style.top-section-gap .plicy_sec a:hover {
  text-decoration: underline;
}

.hero-banner-style.top-section-gap .plicy_sec ul {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
}

.hero-banner-style.top-section-gap .plicy_sec ul li {
  position: relative;
  padding-left: 0px;
  margin-bottom: 14px;
  font-size: 14.5px;
  line-height: 1.7;
  color: #f7f7f7;
}

body.light_theme .hero-banner-style.top-section-gap .plicy_sec ul li {
  color: #475569;
}

/* .hero-banner-style.top-section-gap .plicy_sec ul li::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 10px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: black;
} */

/* ========== RESPONSIVE (last work – keep as is) ========== */

@media screen and (max-width: 1700px) {
  .hero-banner-style.top-section-gap .container {
    max-width: 90%;
  }
}

@media screen and (max-width: 1367px) {
  .hero-banner-style.top-section-gap h1 {
    font-size: 2.8rem;
  }

  section.termsofuse {
    padding: 20px 0px 20px;
  }

  .termsofuse li {
    font-size: 14px;
  }
}

@media screen and (max-width: 1200px) {


  .hero-banner-style.top-section-gap h1 {
    font-size: 30px;
  }

  .hero-banner-style.top-section-gap .container {
    max-width: 100%;
  }

  .hero-banner-style.top-section-gap .section-title {
    margin-bottom: 30px;
  }

  .hero-banner-style.top-section-gap .section-title h1 {
    font-size: 40px;
  }

  .hero-banner-style.top-section-gap.help_sectionbl section.faq_sec .section-title {
    margin-bottom: 0px;
  }

}

@media screen and (max-width: 991px) {

  .hero-banner-style.top-section-gap h1 {
    font-size: 26px;
  }

  .hero-banner-style.top-section-gap section.faq_sec {
    padding: 50px 0px 0px;
  }

  .hero-banner-style.top-section-gap section.faq_sec .section-title {
    margin-bottom: 0px;
  }

  .hero-banner-style.top-section-gap .section-title h1 {
    font-size: 28px;
  }
}

.faq_cards a {
  color: #d1aa67;
}

@media screen and (max-width: 767px) {
  .hero-banner-style.top-section-gap .container {
    max-width: 98%;
  }

  .hero-banner-style.top-section-gap .create-item-wrapper.plicy_sec {
    padding: 18px 20px;
  }

  .hero-banner-style.top-section-gap section.faq_sec {
    padding: 35px 0px 0px;
  }

  .hero-banner-style.top-section-gap .section-title h1 {
    font-size: 24px;
  }

  section.termsofuse {
    padding: 15px 0px 20px;
  }

  section.termsofuse h3 {
    font-size: 17px;
  }

  .termsofuse li {
    font-size: 13px;
    line-height: 22px;
  }

  .hero-banner-style.top-section-gap h1 {
    font-size: 20px;
  }

  section.faq_cards.help_center_faq_cards {
    padding: 10px 0px 20px;
  }

  .help_center_faq_cards .doc_icon img {
    width: 40px;
  }

  .grid.faq_sidebar a.card .doc_icon {
    margin-right: 12px;
  }

  .grid.faq_sidebar a.card {
    padding: 16px 10px 16px 15px;
  }

}

@media screen and (max-width: 660px) {
  .termsofuse h3 {
    font-size: 20px;
  }
}

@media screen and (max-width: 480px) {
  .termsofuse ul {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .hero-banner-style.top-section-gap .section-title h1 {
    font-size: 22px;
  }

}

@media screen and (max-width: 414px) {
  .termsofuse li {
    font-size: 12px;
    line-height: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/GeneralDisclaimer/general.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA,uCAAuC;;AAEvC;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2EAA2E;EAC3E,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA,+DAA+D;;AAE/D;EACE,2EAA2E;EAC3E,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;8BAC4B;EAC5B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;;;GASG;;AAEH,8DAA8D;;AAE9D;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;;EAGE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;AAEF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".hero-banner-style.top-section-gap {\n  color: #fff;\n  background-color: #181a20;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n  position: relative;\n  max-width: 100%;\n  overflow-x: hidden;\n  padding-top: 0;\n  padding-bottom: 40px;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap {\n  color: #0a0a0a;\n  background-color: #ffffff;\n}\n\n.hero-banner-style.top-section-gap a {\n  text-decoration: none;\n  transition: 0.5s all;\n}\n\n.hero-banner-style.top-section-gap img {\n  max-width: 100%;\n}\n\n.hero-banner-style.top-section-gap .container {\n  max-width: 1440px;\n  padding: 0 20px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n}\n\n.hero-banner-style.top-section-gap .row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -12px;\n  margin-right: -12px;\n}\n\n.hero-banner-style.top-section-gap .row>* {\n  padding-left: 12px;\n  padding-right: 12px;\n  box-sizing: border-box;\n}\n\n.hero-banner-style.top-section-gap .align-items-center {\n  align-items: center !important;\n}\n\n.hero-banner-style.top-section-gap .justify-content-center {\n  justify-content: center !important;\n}\n\n.hero-banner-style.top-section-gap .text-center {\n  text-align: center !important;\n}\n\n.hero-banner-style.top-section-gap .col-md-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n@media (min-width: 992px) {\n  .hero-banner-style.top-section-gap .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n}\n\n/* ========== HERO / TITLE ========== */\n\n.hero-banner-style.top-section-gap section.faq_sec {\n  padding: 40px 0 0;\n}\n\n.hero-banner-style.top-section-gap section.faq_sec .section-title {\n  margin-bottom: 20px;\n}\n\n.hero-banner-style.top-section-gap .section-title {\n  margin-bottom: 60px;\n}\n\n.hero-banner-style.top-section-gap .text-gradient {\n  background: linear-gradient(135deg, #e0e0e0 30%, #d1aa67 80%, #d1aa67 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n/* Force the flat gold instead of the global clipped gradient */\n\nbody.light_theme .hero-banner-style.top-section-gap .text-gradient {\n  background: linear-gradient(135deg, #000000 30%, #d1aa67 80%, #d1aa67 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.hero-banner-style.top-section-gap .section-title h1 {\n  font-family: \"Inter\", sans-serif;\n  font-size: 3.4rem;\n  font-weight: 600;\n  line-height: 1.25;\n  margin: 0;\n}\n\n.hero-banner-style.top-section-gap .termsofuse {\n  padding: 40px 0px 60px;\n}\n\n.hero-banner-style.top-section-gap .create-item-wrapper.plicy_sec {\n  background: #ffffff0f;\n  border: 1px solid #e2e8f012;\n  border-radius: 16px;\n  padding: 20px 32px;\n  max-width: 100%;\n  margin: 0 auto 40px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);\n  color: #d9d9d9;\n  font-size: 14.5px;\n  line-height: 1.75;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap .create-item-wrapper.plicy_sec {\n  /* background: #ffffff;\n  border: 1px solid #e2e8f0; */\n  color: #1b1b1c;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec p {\n  margin: 0 0 16px;\n  font-size: 14px;\n  line-height: 1.75;\n  font-weight: 400;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec>p:first-of-type {\n  margin-bottom: 24px;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec h3 {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ededed;\n  margin: 28px 0 14px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e2e8f01f;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap .plicy_sec h3 {\n  color: #0f172a;\n  /* border-bottom: 1px solid #e2e8f0; */\n}\n\n.hero-banner-style.top-section-gap .plicy_sec strong,\n.hero-banner-style.top-section-gap .plicy_sec b {\n  color: #ffffff;\n  font-weight: 700;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap .plicy_sec strong,\nbody.light_theme .hero-banner-style.top-section-gap .plicy_sec b {\n  color: #0f172a;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec a {\n  color: #ce9f4e;\n  text-decoration: none;\n  font-weight: 500;\n  word-break: break-word;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec a:hover {\n  text-decoration: underline;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec ul {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 20px;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec ul li {\n  position: relative;\n  padding-left: 0px;\n  margin-bottom: 14px;\n  font-size: 14.5px;\n  line-height: 1.7;\n  color: #f7f7f7;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap .plicy_sec ul li {\n  color: #475569;\n}\n\n/* .hero-banner-style.top-section-gap .plicy_sec ul li::before {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  top: 10px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: black;\n} */\n\n/* ========== RESPONSIVE (last work – keep as is) ========== */\n\n@media screen and (max-width: 1700px) {\n  .hero-banner-style.top-section-gap .container {\n    max-width: 90%;\n  }\n}\n\n@media screen and (max-width: 1367px) {\n  .hero-banner-style.top-section-gap h1 {\n    font-size: 2.8rem;\n  }\n\n  section.termsofuse {\n    padding: 20px 0px 20px;\n  }\n\n  .termsofuse li {\n    font-size: 14px;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n\n\n  .hero-banner-style.top-section-gap h1 {\n    font-size: 30px;\n  }\n\n  .hero-banner-style.top-section-gap .container {\n    max-width: 100%;\n  }\n\n  .hero-banner-style.top-section-gap .section-title {\n    margin-bottom: 30px;\n  }\n\n  .hero-banner-style.top-section-gap .section-title h1 {\n    font-size: 40px;\n  }\n\n  .hero-banner-style.top-section-gap.help_sectionbl section.faq_sec .section-title {\n    margin-bottom: 0px;\n  }\n\n}\n\n@media screen and (max-width: 991px) {\n\n  .hero-banner-style.top-section-gap h1 {\n    font-size: 26px;\n  }\n\n  .hero-banner-style.top-section-gap section.faq_sec {\n    padding: 50px 0px 0px;\n  }\n\n  .hero-banner-style.top-section-gap section.faq_sec .section-title {\n    margin-bottom: 0px;\n  }\n\n  .hero-banner-style.top-section-gap .section-title h1 {\n    font-size: 28px;\n  }\n}\n\n.faq_cards a {\n  color: #d1aa67;\n}\n\n@media screen and (max-width: 767px) {\n  .hero-banner-style.top-section-gap .container {\n    max-width: 98%;\n  }\n\n  .hero-banner-style.top-section-gap .create-item-wrapper.plicy_sec {\n    padding: 18px 20px;\n  }\n\n  .hero-banner-style.top-section-gap section.faq_sec {\n    padding: 35px 0px 0px;\n  }\n\n  .hero-banner-style.top-section-gap .section-title h1 {\n    font-size: 24px;\n  }\n\n  section.termsofuse {\n    padding: 15px 0px 20px;\n  }\n\n  section.termsofuse h3 {\n    font-size: 17px;\n  }\n\n  .termsofuse li {\n    font-size: 13px;\n    line-height: 22px;\n  }\n\n  .hero-banner-style.top-section-gap h1 {\n    font-size: 20px;\n  }\n\n  section.faq_cards.help_center_faq_cards {\n    padding: 10px 0px 20px;\n  }\n\n  .help_center_faq_cards .doc_icon img {\n    width: 40px;\n  }\n\n  .grid.faq_sidebar a.card .doc_icon {\n    margin-right: 12px;\n  }\n\n  .grid.faq_sidebar a.card {\n    padding: 16px 10px 16px 15px;\n  }\n\n}\n\n@media screen and (max-width: 660px) {\n  .termsofuse h3 {\n    font-size: 20px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .termsofuse ul {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .hero-banner-style.top-section-gap .section-title h1 {\n    font-size: 22px;\n  }\n\n}\n\n@media screen and (max-width: 414px) {\n  .termsofuse li {\n    font-size: 12px;\n    line-height: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
